<template>
    <div class="modal" v-bind:class="modalClass">
        <div id="modal-overlay" @click="back()"></div>
        <article id="modal-edit" v-if="resource">
            <header>
                <figure><i class="icon icon-icon_layers"></i></figure>
                <div>
                    <span class="breadcrumb">
                        Scope <i class="icon icon-icon_arrow-right"></i> Edit
                    </span>
                    <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                </div>
                <div class="spacer"></div>
                <div>
                    <button @click="back()" class="bt-back"><span><i class="icon icon-icon_arrow-left"></i></span></button>
                    <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                </div>
            </header>

            <languages :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

            <tabs :options="{ useUrlFragment: false }">
                <tab name="Information">

                    <form-select label="Parent scope" multiple="false" v-model="resource.parent" :default="resource.parent_id" :options="scopes"></form-select>

                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                        <form-text :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name"></form-text>
                    </div>

                    <form-text label="Slug" v-model="resource.slug" :required="true"></form-text>

                    <form-text label="Website" v-model="resource.website"></form-text>

                    <fieldset>
                        <legend>Email</legend>

                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                            <form-text :lang="client.id" :label="'Nom email'" v-model="resource.translations[client.id].default_email_from_name"></form-text>
                        </div>

                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                            <form-text :lang="client.id" :label="'Email'" v-model="resource.translations[client.id].default_email_from"></form-text>
                        </div>

                    </fieldset>


                    <fieldset>
                        <legend>Localisation</legend>

                        <form-select label="Pays" multiple="false" v-model="resource.country" :default="resource.country_id" :options="$store.state.countries"></form-select>

                        <form-select label="Locales" multiple="true" v-model="resource.locales" :id="locale" :options="$store.state.locales"></form-select>

                    </fieldset>

                </tab>
                <tab name="Echeckin">

                    <fieldset>

                        <legend>Email client</legend>

                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                            <form-text :lang="client.id" :label="'Titre'" v-model="resource.translations[client.id].checkin_email_title" :required="true"></form-text>
                        </div>

                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                            <form-html :lang="client.id" :label="'Contenu HTML'" v-model="resource.translations[client.id].checkin_email_html" :required="true"></form-html>
                        </div>

                    </fieldset>

                    <fieldset>

                        <legend>Message register form</legend>

                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                            <form-text :lang="client.id" :label="'Titre'" v-model="resource.translations[client.id].checkin_register_title" :required="true"></form-text>
                        </div>

                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                            <form-html :lang="client.id" :label="'Contenu HTML'" v-model="resource.translations[client.id].checkin_register_html" :required="true"></form-html>
                        </div>

                    </fieldset>

                    <fieldset>

                        <legend>Message de remerciement  register form</legend>

                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                            <form-text :lang="client.id" :label="'Titre'" v-model="resource.translations[client.id].checkin_register_thanks_title" :required="true"></form-text>
                        </div>

                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                            <form-html :lang="client.id" :label="'Contenu HTML'" v-model="resource.translations[client.id].checkin_register_thanks_html" :required="true"></form-html>
                        </div>

                    </fieldset>

                    <fieldset>

                        <legend>Paramètres d'affichage</legend>

                        <form-toggle label="Résumé formulaire" v-model="resource.checkin_show_resume"></form-toggle>

                        <form-toggle label="Complément adresse" v-model="resource.checkin_street_complement"></form-toggle>

                        <form-toggle label="Commentaire" v-model="resource.checkin_comment"></form-toggle>

                        <form-toggle label="Newsletter" v-model="resource.checkin_newletter"></form-toggle>

                        <form-toggle label="Heure arrivée" v-model="resource.checkin_arrival_time"></form-toggle>

                    </fieldset>

                    <fieldset>

                        <legend>Autres paramètres</legend>

                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                            <form-text :lang="client.id" :label="'URL terms & conditions'" v-model="resource.translations[client.id].checkin_term_and_conditions_url" :required="true"></form-text>
                        </div>

                    </fieldset>


                </tab>
                <tab name="Theme">

                    <form-file label='Logo' v-model="resource.picture_id" width="200"></form-file>

                    <component-attributes v-model="resource" :locale="locale"></component-attributes>

                </tab>
                <tab name="Adresses">

                    <component-address v-model="resource.addresses"></component-address>

                </tab>
                <tab name="Env">

                    <div v-for="item in resource.env">
                        <form-text :label="item.id" v-model="item.value"></form-text>
                    </div>

                </tab>
            </tabs>
        </article>
    </div>
</template>
<script>


    import ScopeService from './ScopeService.js';
    import ComponentAddress from "../../components/Address.vue";
    import ComponentAttributes from "../../components/Attributes.vue";
    import Edit from '../../layouts/Edit.vue';

    export default {
        extends: Edit,
        components: {
            'component-address': ComponentAddress,
            'component-attributes': ComponentAttributes,
        },
        data () {
            return {
                defaultColor: '#000000',
                resource: {
                    addressable: [],
                    workspaces: []
                },
                fonts: [
                    {id:'hind-vadodara', name:'hind-vadodara'},
                    {id:'roboto', name:'roboto'},
                    {id:'open-sans', name:'open-sans'}
                ],
                scopes: [],
                isLoading: false,
                paginationOrders: [
                    {id:'new', name:'Nouveautés'},
                    {id:'name', name:'Nom'},
                    {id:'rating', name:'Rating'},
                    {id:'price_asc', name:'Prix croissants'},
                    {id:'price_desc', name:'Prix décroissants'}
                ]
            }
        },
        mounted: function(){


        },
        methods:{
            resourceLoaded: function(){
                // Translations
                this.setTranslations(['name','default_email_from_name', 'default_email_from','checkin_email_title','checkin_email_html','checkin_register_title','checkin_register_html','checkin_register_thanks_title','checkin_register_thanks_html','checkin_term_and_conditions_url']);
                if( this.resource.values ){
                    for( var i=0; i<this.resource.values.length ; i++){
                        this.setTranslationsTo(this.resource.values[i], ['name','default_email_from_name','default_email_from','checkin_email_title','checkin_email_html','checkin_register_html','checkin_register_thanks_title','checkin_register_thanks_html','checkin_term_and_conditions_url']);
                    }
                }

                // Attributes
                /*
                if(this.resource && this.resource.id != null) {
                    for(let attribute of this.resource.attributes){
                        this.resource[attribute.slug] = attribute.value;
                    }
                }*/

                ScopeService.query().then(response => {
                    this.scopes = [];
                    this.isLoading = false;

                    if(this.resource && this.resource.id != null) {
                        for(let item of response.data.data){

                            if((this.resource.parents.indexOf(item.id.toString()) < 0 && this.resource.children.indexOf(item.id.toString()) < 0)){
                                this.scopes.push(item);
                            }
                        }
                    }else{
                        this.scopes = response.data.data;
                    }

                })

            },
            getResource: function(){
                return {name: 'scope', api: ScopeService}
            },
            submit: function(){
                if( !this.beforeUpdate() ){
                    return false;
                }

                if( this.$route.meta.action == "edit" ){

                    this.getResource().api.update(this.$route.params.id, this.resource).then((response) => {

                        this.$store.dispatch("user").then(() => {
                            this.$store.dispatch("load").then(() => {

                            });
                        });

                        this.$emit('refresh', this);
                        this.back();
                    })

                }else{

                    this.getResource().api.create(this.resource).then((response) => {

                        this.$store.dispatch("user").then(() => {
                            this.$store.dispatch("load").then(() => {

                            });
                        });

                        this.$emit('refresh', this);
                        this.back();
                    })
                }

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/scope/Edit.vue